import numberUtilities from "./numberUtilities"
import stringHelpers from "./stringHelpers"

export default {
    requiredField(node, fieldValue) {
        if (node) {
            if (stringHelpers.isNullOrEmpty(fieldValue)) {
                node.classList.add("was-validated")
            } else {
                node.classList.remove("was-validated")
            }
        }
    },

    valueNotEmptyAndGreaterThanZero(node, fieldValue) {
        if (numberUtilities.isNumberGreaterThanZero(fieldValue)) {
            node.classList.add("d-none")
        }
        else {
            node.classList.remove("d-none")
        }
    }
}